<template>
  <div id="index">
    <!-- 下载弹框 -->
    <div class="tip" @click="downnow">
      <div class="close" @click.stop="close($event)">
        <img src=".././assets/img/关闭.png" alt class="closeImg" />
      </div>
      <div class="logo">
        <img src=".././assets/img/图标.png" alt class="logo-img" />
      </div>
      <div class="title">有味生活，品味健康</div>
      <a href="http://app.jingmaie-co.cn/" class="down">立即下载</a>
    </div>
    <!-- <div class="active" @click="activePage">
      活动页面
    </div>-->
    <!-- 搜素 -->
    <div class="search" @click="search">
      <img src="../assets/img/搜索商品.jpg" alt />
    </div>
    <!-- 轮播图 -->
    <div class="banner">
      <van-swipe :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in lunboImg" :key="index" @click="clickBanner(index)">
          <img
            :src="lbflag?item.pic:'http://youwei.jingmaie-co.cn/'+item.pic"
            alt
            class="bannerImg"
          />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 标签栏 -->
    <div class="label">
      <span
        v-for="(item,index) in goodsList"
        :key="index"
        @click="getType(index)"
        :class="{actives:isActiveIndex==index}"
      >{{item.tab_title}}</span>
    </div>
    <!-- 商品列表 -->
    <div id="goodsList">
      <van-list>
        <van-cell
          class="goodsInfo"
          v-for="item in goodsDetails"
          :key="item.id"
          @click="goDetail(item.goods_id)"
        >
          <div class="goodsImg">
            <img
              :src="spflag?item.original_img:'http://youwei.jingmaie-co.cn/'+item.original_img"
              alt
            />
          </div>
          <div class="msg">
            <span class="info">
              <span class="self">自营</span>

              {{item.goods_name}}
            </span>
          </div>
          <div class="price">￥{{item.shop_price}}</div>
          <span class="oldPrice">￥{{item.market_price}}</span>
          <span class="pay">
            {{item.sales_sum}}
            <span>人付款</span>
          </span>
        </van-cell>
      </van-list>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <p>京迈（湖北）电子商务股份有限公司</p>
      <p>联系电话：400-1383633</p>
      <p>地址：武汉东湖新技术开发区高新二路388号</p>
      <p>武汉光谷国际生物医药企业加速器3.1期16栋1层01厂房号</p>
      <p style="margin-bottom:0">京迈（湖北）电子商务股份有限公司，涵盖美妆护肤、膳食营养及个人清护，致力为您打造轻妆简食的健康、品质新生活。</p>
    </div>
  </div>
</template>
<script>
import { goodsInfo } from "@/api";
export default {
  name: "index",
  data() {
    return {
      lunboImg: [],
      goodsList: [],
      goodsDetails: [],
      isActiveIndex: 0,
      lbflag: false,
      spflag: true,
    };
  },
  created() {
    this.getGoods();
  },
  methods: {
    activePage() {
      this.$router.push("/activity");
    },
    // 立即下载按钮
    downnow() {
      window.location.href = "http://app.jingmaie-co.cn/";
    },
    //获取首页数据
    async getGoods() {
      let res = await goodsInfo();
      if (res.status === 1) {
        this.lunboImg = res.result.blocks[0].nav; //轮播图列表
        this.goodsList = res.result.blocks[1].nav;
        this.goodsDetails = this.goodsList[0].goods_list;
        for (var i = 0; i < this.lunboImg.length; i++) {
          if (this.lunboImg[i].pic.indexOf("http") != -1) {
            this.lbflag = true;
          } else {
            this.lbflag = false;
          }
        }

        for (var i = 0; i < this.goodsDetails.length; i++) {
          if (this.goodsDetails[i].original_img.indexOf("http") != -1) {
            
            this.spflag = true;
          } else {
            this.spflag = false;
          }
        }
      } else {
        this.$toast(res.msg);
      }
    },
    // 点击获取分类列表
    getType(index) {
      // 给当前点击的颜色添加类样式
      this.isActiveIndex = index;
      this.goodsDetails = this.goodsList[index].goods_list;
    },
    // 点击轮播图 跳转到对应链接
    clickBanner(index) {
      let id = this.lunboImg[index].app_url;
      if (this.lunboImg[index].url_type === 3) {
        this.$router.push({ name: "goodsDetail", params: { id: id } });
      } else if (this.lunboImg[index].url_type === 5) {
        window.location.href = "http://youwei.jingmaie-co.cn" + id;
      }
    },
    // 关闭下载app窗口
    close(e) {
      e.currentTarget.parentElement.style.display = "none";
    },
    // 跳转到商品详情页
    goDetail(id) {
      this.$router.push({ name: "goodsDetail", params: { id: id } });
    },
    // 点击跳转搜索页面
    search() {
      this.$router.push("searchPage");
    },
  },
};
</script>
<style lang="less" scoped>
#index {
  height: 100%;
  width: 750px;
  padding-top: 98px;
  margin: 0;
  position: relative;
  background-color: #f6f6f6;
  box-sizing: border-box;
  transform: none;
  .active {
    width: 100%;
    height: 100px;
    font-size: 32px;
    text-align: center;
    line-height: 100px;
    background-color: #f5f5f5;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
  }
  .tip {
    width: 750px;
    height: 98px;
    background-color: #000000;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .close {
      width: 27px;
      height: 24px;
      font-size: 40px;
      margin-top: 25px;
      margin-left: 29px;
      float: left;
      color: #a0a0a0;
      .closeImg {
        width: 27px;
        height: 26px;
      }
    }
    .logo {
      width: 74px;
      height: 74px;
      position: absolute;
      top: 11px;
      left: 140px;
      .logo-img {
        width: 74px;
        height: 74px;
      }
    }
    .title {
      width: 260px;
      height: 26px;
      font-size: 27px;
      color: #ffffff;
      position: absolute;
      top: 35px;
      left: 268px;
    }
    .down {
      width: 154px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      font-size: 30px;
      background: #ff544f;
      margin-top: 30px;
      float: right;
      color: #fff;
      margin-right: 29px;
      border-radius: 9px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .search {
    width: 750px;
    height: 98px;
    background-color: #f6f6f6;
    margin-bottom: 25px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    transform: none;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .banner {
    width: 750px;
    height: 320px;
    .van-swipe {
      width: 750px;
      height: 320px;
      .van-swipe-item {
        width: 750px;
        height: 320px;
        .bannerImg {
          width: 750px;
          height: 320px;
          pointer-events: none;
        }
      }
    }
    .custom-indicator {
      position: absolute;
      right: 5px;
      bottom: 5px;
      padding: 2px 5px;
      font-size: 12px;
      color: #fff;
      background: #fff;
    }
  }
  .label {
    font-size: 30px;
    color: #4a4a4a;
    margin: 20px 0;
    display: flex;
    span {
      flex: 1;
      text-align: center;
      border-right: 1px solid #434343;
    }
    .actives {
      color: #ff544f;
    }
  }
  .label span:last-child {
    border: none;
  }
  #goodsList {
    width: 750px;
    padding: 0 25px;
    box-sizing: border-box;
    background-color: #f6f6f6;
    /deep/ .van-list {
      width: 100%;
    }
    /deep/ .goodsInfo.van-cell {
      // margin-right: 10px;
      padding: 10px;
      display: inline-block;
      width: 340px;
      height: 496px;
      box-sizing: border-box;
      margin: 0 10px 10px 0;
    }
    .goodsInfo {
      display: inline-block;
      background-color: #fff;
      box-sizing: border-box;
      position: relative;
      z-index: 99;
      .goodsImg {
        width: 320px;
        height: 320px;
        img {
          width: 320px;
          height: 320px;
          border-radius: 10px;
        }
      }
      .msg {
        height: 100px;
        .self {
          display: inline-block;
          margin: 0;
          margin-right: 19px;
          width: 60px;
          height: 30px;
          color: #fff;
          background-color: #ff544f;
          border-radius: 5px;
          font-size: 19px;
          line-height: 30px;
          text-align: center;
        }
        .info {
          height: 90px;
          width: 300px;
          color: #2f2f2f;
          font-size: 24px;
          line-height: 44px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-box-orient: vertical;
        }
      }
      .price {
        height: 25px;
        color: #ff544f;
        font-size: 32px;
        margin: 0;
        margin-bottom: 8px;
        margin-left: -6px;
      }
      .oldPrice {
        width: 62px;
        height: 16px;
        font-size: 20px;
        color: #7a797a;
        text-decoration: line-through;
      }
      .pay {
        font-size: 24px;
        color: #7a797a;
        margin-bottom: 20px;
        float: right;
      }
    }
  }
  .footer {
    text-align: center;
    padding: 0 30px 50px;
    p {
      margin: 6px;
    }
  }
}
</style>